<template>
  <div>
    <Headtop :isbanner="false"/>
    <div class="container">
      <div class="mail-header flex-between">
        <h3>
          <img src="@/assets/images/mulu.png" alt=""/>
          <span>个人邮箱</span>
        </h3>
        <el-button type="primary" icon="el-icon-d-arrow-left" size="medium" @click="goBack">返 回</el-button>
      </div>
      <div class="mail-box">
        <div class="mail-title">
          尊敬的 {{ seeker.name }} ：
        </div>
        <div class="mailcont">
          <p v-html="record.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {SEEKER_INFO} from "@/store/mutation-types"
import {getAction} from "@/api/manage";

export default {
  data() {
    return {
      seeker: {},
      seekerId: '',
      record: {},
      url: '/letter/detail'
    };
  },
  created() {
    this.seeker = Vue.ls.get(SEEKER_INFO)
    this.id = this.$route.params.id
    this.initDetail()
  },
  methods: {
    goBack(){
      this.$router.push({name: "MailList"});
    },
    initDetail() {
      let _this = this
      if (_this.id === undefined){
        _this.record.content = '<p>暂无数据</p>'
        return
      }
      getAction(_this.url, {id: _this.id,seekerId: _this.seeker.id}).then(res => {
        if (res.success) {
          _this.$nextTick(() => {
            _this.record = res.result
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.mail-box {
  width: 863px;
  margin: 40px auto;

  .mail-title {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  p {
    line-height: 30px;
  }
}
</style>
